import React, { useState, useEffect, useRef } from "react";
import he from "he";
import Misc from "../../utils/misc";
import Button from "./button";

interface Props {
    name: string;
    placeholder: string;
    changeDefault?: number;
    defaultValue?: string;
    updateChange?: (value: any) => void;
    className?: string;
    counter?: boolean;
    alwaysCounter?: boolean;
    maxCounter?: number;
    focusOut?: (value: any, customId?: any) => void;
    sendable?: { value: string; active?: boolean; color: string; small: boolean; send: (value: string) => void };
    container?: boolean;
    autoResize?: boolean;
}

const Textarea: React.FC<Props> = ({ name, placeholder, changeDefault, defaultValue, updateChange, className, counter, maxCounter = 0, focusOut, sendable, alwaysCounter, container = true, autoResize = false }) => {
    const [value, setValue] = useState("");
    const [defaultCount, setDefaultCount] = useState(0);
    const [focus, setFocus] = useState(false);

    const textareaRef = useRef(null);

    const auto_resize = () => {
        const textarea: any = textareaRef.current;
        textarea.style.height = "auto";
        textarea.style.height = `${textarea.scrollHeight}px`;
    };

    useEffect(() => {
        if (changeDefault !== defaultCount && changeDefault) {
            setDefaultCount(changeDefault);
            setValue(defaultValue ? he.decode(defaultValue) : "");
        }
    });

    return (
        <div className={container ? "input-container " + (className ? className : "") : className}>
            <textarea
                ref={textareaRef}
                style={autoResize ? { overflow: "hidden", resize: "none", height: "50px" } : {}}
                placeholder={placeholder}
                value={value}
                id={name}
                name={name}
                onChange={(e) => {
                    if (autoResize) auto_resize();
                    setValue(e.target.value);
                    if (updateChange) updateChange(e.target.value);
                }}
                className={className ? className : ""}
                onFocus={() => {
                    setFocus(true);
                }}
                onBlur={() => {
                    setFocus(false);
                    if (focusOut) {
                        focusOut(value);
                    }
                }}
            >
                {he.decode(value)}
            </textarea>
            {(counter === true && value.length >= Math.round(maxCounter * 0.8)) || alwaysCounter ? (
                <div className={maxCounter && maxCounter < value.length ? "red d-inline-block" : "d-inline-block"}>
                    <small className={maxCounter && maxCounter < value.length ? "red" : ""}>
                        {value.length}
                        {maxCounter ? `/${maxCounter}` : ""}
                    </small>
                </div>
            ) : (
                <></>
            )}
            {sendable ? (
                <div className="float-right d-inline-block">
                    <Button
                        small={sendable.small}
                        value={sendable.value}
                        color={sendable.color}
                        active={sendable.active || false}
                        onClick={() => {
                            sendable.send(value);
                        }}
                    />
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

export default Textarea;
